const Footer = () => {
  return (
    <footer>
      <p>
        © 2025 Sunil Kublalsingh.
        <br />
        All rights reserved.
      </p>
    </footer>
  );
};

export default Footer;
